import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'

Vue.use(Vuex)

export const createStore = () => {
    return new Vuex.Store({
        modules: {
            categories: require("./categories").default,
            authen: require("./authen").default,
            views: require("./views").default,
            tool: require("./tool").default,
            chrome: require("./chrome").default,
            mario: require("./mario").default,
            supporter: require("./supporter").default,
            socket: require("./socket").default,
        },
        state: {
            useragent: {
                member: null,
                headers: {},
            },
        },
        actions,
        mutations,
        getters
    })
}



// WEBPACK FOOTER //
// src/store/index.js